import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'

import * as actions from './actions'
import { RANKINGS } from './constants'
import RankingsBox from './RankingsBox'
import * as selectors from './selectors'

const RankingsBoxContainer = props => {
  useEffect(() => {
    if (props.ranking === RANKINGS.HOURS_REVENUE) {
      if (props.isHourlyCountriesIndicator) {
        props.fetchRankingHourlyCountries()
      } else {
        props.fetchRankingHourlyStores()
      }
    } else {
      props.fetchRankingsCountries()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.dateCurrent, props.indicator, props.ranking])

  return <RankingsBox {...props} />
}

RankingsBoxContainer.propTypes = {
  dateCurrent: PropTypes.string.isRequired,
  fetchRankingHourlyCountries: PropTypes.func.isRequired,
  fetchRankingHourlyStores: PropTypes.func.isRequired,
  fetchRankingsCountries: PropTypes.func.isRequired,
  indicator: PropTypes.string.isRequired,
  isHourlyCountriesIndicator: PropTypes.bool.isRequired,
  ranking: PropTypes.string.isRequired,
}

const mapStateToProps = state => ({
  dateCurrent: state.datePicker.dateCurrent,
  indicator: selectors.indicator(state),
  isFetchError: selectors.isFetchError(state),
  isFetching: selectors.isFetching(state),
  ranking: selectors.ranking(state),
  isHourlyCountriesIndicator: selectors.isHourlyCountriesIndicator(state),
})

const mapDispatchToProps = {
  fetchRankingHourlyCountries: actions.fetchRankingHourlyCountries,
  fetchRankingHourlyStores: actions.fetchRankingHourlyStores,
  fetchRankingsCountries: actions.fetchRankingsCountries,
}

export default connect(mapStateToProps, mapDispatchToProps)(RankingsBoxContainer)
